import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import HealthCentersListBody from "components/ClinicalManagement/HealthCenters/List/HealthCentersListBody";

const HealthCenters = () => {
  useEffect(() => {
    document.title = "Health Centers";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <HealthCentersListBody />
    </main>
  );
};

export default HealthCenters;
